module.exports = __webpack_public_path__ + "static/img/avatar.ce739dae.png";